import { render, staticRenderFns } from "./quick-quote.vue?vue&type=template&id=2f8f1662&scoped=true&"
import script from "./quick-quote.vue?vue&type=script&lang=js&"
export * from "./quick-quote.vue?vue&type=script&lang=js&"
import style0 from "./quick-quote.vue?vue&type=style&index=0&id=2f8f1662&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8f1662",
  null
  
)

export default component.exports